import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgbDropdown, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { Daterangepicker } from 'ng2-daterangepicker';

import { RoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { UserComponent } from './header/user/user.component';
import { NotificationsComponent } from './header/notifications/notifications.component';
import { LogoutComponent } from './header/logout/logout.component';
import { TextInputComponent } from './shared/atoms/text-input/text-input.component';
import { OverviewComponent } from './overview/overview.component';
import { ExperiencesComponent } from './experiences/experiences.component';
import { NavigationComponent } from './header/navigation/navigation.component';
import { BookingsComponent } from './bookings/bookings.component';
import { ReportsComponent } from './reports/reports.component';
import { ManageComponent } from './manage/manage.component';
import { DateInputComponent } from './shared/atoms/date-input/date-input.component';
import { DropdownComponent } from './shared/atoms/dropdown/dropdown.component';
import { CounterComponent } from './shared/atoms/counter/counter.component';
import { ProductsComponent } from './experiences/products/products.component';
import { CalendarComponent } from './experiences/calendar/calendar.component';
import { BookDetailsComponent } from './experiences/booking/book-details/book-details.component';
import { BookTransportComponent } from './experiences/booking/book-transport/book-transport.component';
import { BookingComponent } from './experiences/booking/booking.component';
import { ProductDetailsComponent } from './experiences/products/product-details/product-details.component';
import { ProductEventsComponent } from './experiences/products/product-events/product-events.component';
import { AuthenticationService } from './shared/api/authentication/authentication.service';
import { UserService } from './shared/api/resources/user/user.service';
import { ResourcesService } from './shared/api/resources/resources.service';
import { AgentService } from './shared/api/resources/agent/agent.service';
import {SettingsService} from './shared/api/resources/settings/settings.service';
import { NgxGalleryModule } from 'ngx-gallery';
import {NotificationsService} from './shared/api/resources/notifications/notifications.service';
import { LoadingComponent } from './shared/atoms/loading/loading.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { BookingDetailsComponent } from './shared/atoms/booking-details/booking-details.component';
import { PaxDropdownComponent } from './shared/atoms/pax-dropdown/pax-dropdown.component';
import { LoginComponent } from './login/login.component';
import { PartnersComponent } from './manage/partners/partners.component';
import { AccountsComponent } from './manage/accounts/accounts.component';
import {FocusDirective} from './shared/utils/focus.directive';
import {ToastModule, ToastOptions} from 'ng2-toastr/ng2-toastr';
import {ToasterService} from './shared/global/toaster.service';
import {BookingService} from './shared/api/resources/booking/booking.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AgentReservationService} from './shared/api/resources/agent-reservation/agent-reservation.service';
import {WidgetService} from './shared/api/resources/widget/widget.service';
import { PaginationComponent } from './shared/atoms/pagination/pagination.component';
import { ToggleComponent } from './shared/atoms/toggle/toggle.component';
import {UiSwitchModule} from 'ngx-toggle-switch/src';
import {LoadingService} from './shared/global/loading.service';
import { IntercomModule, INTERCOM_DIRECTIVES } from 'ng2-intercom';
import { NotificationDetailsComponent } from './shared/atoms/notification-details/notification-details.component';
import { ProductEventDayCardComponent } from './shared/atoms/product-event-day-card/product-event-day-card.component';
import {IventoryService} from './shared/api/resources/iventory/iventory.service';
import {SupplierService} from './shared/api/resources/supplier/supplier.service';
import { ImageUploadComponent } from './shared/atoms/image-upload/image-upload.component';
import {AccountService} from './shared/api/resources/account/account.service';
import { UserDetailsComponent } from './shared/atoms/user-details/user-details.component';
import { DayProductEventsCardComponent } from './shared/atoms/day-product-events-card/day-product-events-card.component';
import { PageHeadingComponent } from './shared/atoms/page-heading/page-heading.component';
import { DatePickerComponent } from './shared/atoms/date-picker/date-picker.component';
import { BookExtrasComponent } from './experiences/booking/book-extras/book-extras.component';
import {ProtocolService} from './shared/global/protocol.service';
import { ExploreComponent } from './explore/explore.component';
import {CommunityService} from './shared/api/resources/community/community.service';
import { MandatoryExtrasWarningComponent } from './shared/atoms/mandatory-extras-warning/mandatory-extras-warning.component';
import { SupplierComponent } from './explore/supplier/supplier.component';
import {SupplierDetailsComponent} from './shared/atoms/supplier-details/supplier-details.component';
import { ReportSupplierComponent } from './shared/atoms/report-supplier/report-supplier.component';
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';

export class CustomToastOption extends ToastOptions {
  positionClass = 'toast-top-center';
  showCloseButton = true;
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    UserComponent,
    NotificationsComponent,
    LogoutComponent,
    TextInputComponent,
    OverviewComponent,
    ExperiencesComponent,
    NavigationComponent,
    BookingsComponent,
    ReportsComponent,
    ManageComponent,
    DateInputComponent,
    DropdownComponent,
    CounterComponent,
    ProductsComponent,
    CalendarComponent,
    BookDetailsComponent,
    BookTransportComponent,
    BookingComponent,
    ProductDetailsComponent,
    ProductEventsComponent,
    LoadingComponent,
    UserProfileComponent,
    BookingDetailsComponent,
    PaxDropdownComponent,
    LoginComponent,
    PartnersComponent,
    AccountsComponent,
    FocusDirective,
    PaginationComponent,
    ToggleComponent,
    INTERCOM_DIRECTIVES,
    NotificationDetailsComponent,
    ProductEventDayCardComponent,
    ImageUploadComponent,
    UserDetailsComponent,
    DayProductEventsCardComponent,
    PageHeadingComponent,
    DatePickerComponent,
    BookExtrasComponent,
    ExploreComponent,
    MandatoryExtrasWarningComponent,
    SupplierComponent,
    SupplierDetailsComponent,
    ReportSupplierComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RoutingModule,
    HttpClientModule,
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgxGalleryModule,
    Daterangepicker,
    ToastModule.forRoot(),
    UiSwitchModule,
    IntercomModule,
    SnotifyModule
  ],
  providers: [
    AuthenticationService,
    ResourcesService,
    UserService,
    AgentService,
    AgentReservationService,
    AccountService,
    BookingService,
    SupplierService,
    IventoryService,
    WidgetService,
    SettingsService,
    NotificationsService,
    BookDetailsComponent,
    ToasterService,
    {
      provide: ToastOptions,
      useClass: CustomToastOption
    },
    LoadingService,
    ProtocolService,
    CommunityService,
    NgbDropdown,
    {
      provide: 'SnotifyToastConfig',
      useValue: ToastDefaults
    },
    SnotifyService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    BookingDetailsComponent,
    NotificationDetailsComponent,
    UserDetailsComponent,
    MandatoryExtrasWarningComponent,
    ReportSupplierComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts